export const TABLE_WIDTH_STORAGE_PLACE = 200
export const TABLE_WIDTH_BRAND = 200
export const TABLE_WIDTH_MODEL = 200
export const TABLE_WIDTH_FOUND = 160
export const TABLE_WIDTH_PLATE = 150
export const TABLE_WIDTH_PARTNER = 200
export const TABLE_WIDTH_DOT_CHOICE = 30

export const TABLE_ROWS_PER_PAGE = 10
export const TABLE_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100]

export const TABLE_DIRECTION_ASC = 'asc'
export const TABLE_DIRECTION_DESC = 'desc'
